angular.module('dpw.services').factory('freeExtensionService', ['$q', 'api', 'popupUtil', function ($q, api, popupUtil) {
    var service = {};

    service.invitePreCheck = function (data) {
        return api.call(api.myAccount.freeExtension.invitePreCheck(data), angular.noop, angular.noop);
    };

    service.sendInvitation = function (data) {
        return api.call(api.myAccount.freeExtension.sendInvitation(data), angular.noop, angular.noop);
    };

    service.checkSignUpPrerequisite = function (data) {
        return api.call(api.myAccount.freeExtension.checkSignUpPrerequisite(data), angular.noop, angular.noop);
    };

    service.signUp = function (data) {
        return api.call(api.myAccount.freeExtension.signUp(data), angular.noop, angular.noop);
    };

    service.loadMaxCount = function () {
        return $q(function (resolve) {
            api.call(api.myAccount.freeExtension.maxCount(), function (data) {
                resolve(data.value);
            });
        });
    };

    service.getSecurityQuestions = function () {
        return api.call(api.securityQuestion.list(), angular.noop, angular.noop)
            .then(function (data) {
                var records = _.get(data, 'records', []);
                return records.reduce(function (accumulated, record) {
                    if (record.showInSignUp) {
                        accumulated.push({
                            id: record.id,
                            text: record.questionText
                        });
                    }
                    return accumulated;
                }, []);
            });
    };

    service.congratulateSuccessfulSignup = function (accountNumber, extensionNumber) {
        popupUtil.ok({
            title: 'Congratulations!',
            content: 'You have successfully joined the account: <strong>' + accountNumber + '</strong> with ext <strong>' + extensionNumber + '</strong>. You can use this number with ext or your email address to login <a href="/">Developer Portal</a>.',
            btnName: 'Login',
            showCloseBtn: false,
            callback: function () {
                window.location = '/login';
            }
        });
    };

    return service;
}]);
